import { IAlterarCentroCustoFuncionariosUseCase } from "../../../presentation/useCases/update/alterar_centro_custo_funcionarios_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * AlterarCentroCustoFuncionariosUseCase
 */

export class AlterarCentroCustoFuncionariosUseCase implements IAlterarCentroCustoFuncionariosUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async alterarCentroCustoFuncionarios(
    idCentroCusto: number,
    funcionarios: number[],
  ): Promise<void> {
    await this.repository.alterarFuncionariosCentroCusto(
      idCentroCusto,
      funcionarios,
    );
  }
}
